export default __webpack_public_path__ + "static/media/import-rows.87bd716f.png";